// extracted by mini-css-extract-plugin
export var adjacentSlide = "_mu-9";
export var arrowButtonContainer = "_mu-5";
export var arrowButtonIcon = "_mu-6";
export var carouselArrowButton = "_mu-2";
export var carouselElementContainer = "_mu-1";
export var currentSlide = "_mu-8";
export var left = "_mu-3";
export var otherSlide = "_mu-a";
export var productCarouselContainer = "_mu-0";
export var right = "_mu-4";
export var sliderOverflow = "_mu-7";